import MainToast from '@/components/core/ui/Toasts/MainToast'
import Toast, { useToast, POSITION } from 'vue-toastification'

const toastInterface = useToast()
const toastFunc = (options = {}) => {
  // Компонент тоста
  const toastComponent = {
    component: MainToast,

    props: {
      options: {
        icon: null,
        closeButton: false,
        title: options?.title,
        text: options?.text,
        group: options?.group,
      },
    },
  }

  // Настройки тоста
  const toastConfiguration = {
    // Тип тоста info | success | warning | error
    type: options?.group || 'success',

    timeout: options?.timeout || 5000,

    position: options?.position || POSITION.TOP_CENTER,

    toastClassName: options?.toastClassName || 'core-toast',

    bodyClassName: options?.bodyClassName || 'core-toast-body',
  }

  toastInterface(toastComponent, toastConfiguration)
}

export {
  toastFunc,
}

export default {
  install: (app) => {
    app.use(Toast, {
      icon: null,
      closeButton: false,
      showCloseButtonOnHover: false,
      hideProgressBar: true,
      transition: 'Vue-Toastification__fade',
      draggablePercent: 0.2,
    })

    // const toastInterface = useToast()
    app.config.globalProperties.toast = toastFunc
    // app.config.globalProperties.toast = (options = {}) => {
    //   console.log('toast', options)
    //   // Компонент тоста
    //   const toastComponent = {
    //     component: MainToast,
    //     props: {
    //       options: {
    //         title: options?.title,
    //         text: options?.text,
    //         group: options?.group,
    //       },
    //     },
    //   }
    //   // Настройки тоста
    //   const toastConfiguration = {
    //     // Тип тоста info | success | warning | error
    //     type: options?.group || 'success',

    //     timeout: options?.timeout || 5000,

    //     position: options?.position || POSITION.TOP_CENTER,

    //     toastClassName: options?.toastClassName || 'core-toast',

    //     bodyClassName: options?.bodyClassName || 'core-toast-body',
    //   }

    //   toastInterface(toastComponent, toastConfiguration)
    // }

    app.provide('toast', app.config.globalProperties.toast)
  },
}
